import { render, staticRenderFns } from "./Bookings.vue?vue&type=template&id=2b640946&"
import script from "./Bookings.vue?vue&type=script&lang=ts&"
export * from "./Bookings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports